import * as cookie from 'js-cookie';
import { trackIdentity } from './tracking';

const AUTH_TOKEN_KEY = 'x-token';
const KC_TOKEN_KEY = 'keycloak-token';
const MERCHANT_ID = 'x-merchant';
const MERCHANT_TIER = 'x-tier';
const USER_ID = 'user-id';

let _token = cookie.get(AUTH_TOKEN_KEY);
let _kcToken = cookie.get(KC_TOKEN_KEY);
let _merchant = cookie.get(MERCHANT_ID);
let _tier = cookie.get(MERCHANT_TIER);
let _user_id = cookie.get(USER_ID);
let _key = void 0;

export default {
  AUTH_TOKEN_KEY,
  KC_TOKEN_KEY,

  get token() {
    return _token || cookie.get(AUTH_TOKEN_KEY);
  },

  set token(token) {
    cookie.set(AUTH_TOKEN_KEY, token);
    _token = token;
  },

  get kcToken() {
    return _kcToken || cookie.get(KC_TOKEN_KEY);
  },

  set kcToken(token) {
    cookie.set(KC_TOKEN_KEY, token);
    _kcToken = token;
  },

  get userId() {
    return _user_id || cookie.get(USER_ID);
  },

  set userId(id) {
    cookie.set(USER_ID, id);
    _user_id = id;
  },

  get merchant() {
    return _merchant || cookie.get(MERCHANT_ID);
  },

  set merchant(id) {
    if (!id) {
      cookie.remove(MERCHANT_ID);
    } else {
      cookie.set(MERCHANT_ID, id);
      _merchant = id;

      trackIdentity({
        merchantId: id,
      });
    }
  },

  getMerchant() {
    return _merchant || cookie.get(MERCHANT_ID);
  },

  get tier() {
    return _tier || cookie.get(MERCHANT_TIER);
  },

  set tier(tier) {
    if (!tier) {
      cookie.remove(MERCHANT_TIER);
    } else {
      cookie.set(MERCHANT_TIER, tier);
      _tier = tier;

      trackIdentity({
        tierId: tier,
      });
    }
  },

  getTier() {
    return _tier || cookie.get(MERCHANT_TIER);
  },

  isAuthenticated() {
    return !!_token || !!_kcToken;
  },

  set key(key) {
    _key = key;
  },

  get key() {
    return _key;
  },

  reset() {
    cookie.remove(AUTH_TOKEN_KEY);
    cookie.remove(MERCHANT_ID);
    cookie.remove(MERCHANT_TIER);
    cookie.remove(USER_ID);
    cookie.remove(KC_TOKEN_KEY);
    _token = void 0;
    _merchant = void 0;
  },
};
